import { EmptyState } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { AIRFLOW_TYPE, routes } from '../../lib/viva';
import { EntityArgoAppsCell } from '../catalog/cells';
import { airflowColumns } from '../catalog/columns';
import { TypedCatalogPage } from '../catalog/TypedCatalogPage';

const columns = airflowColumns<CatalogTableRow>(row => (
  <EntityArgoAppsCell entity={row.entity} />
));

export const AirflowPage = () => (
  <TypedCatalogPage
    section="airflow"
    title="Airflow"
    subtitle="Оркестрация: инстансы Apache Airflow команд, у каждого — свой репозиторий DAG'ов, образ и Postgres"
    kind="component"
    type={AIRFLOW_TYPE}
    columns={columns}
    create={{ title: 'Новый Airflow', to: routes.newAirflow }}
    support="Инстанс создаётся шаблоном «Airflow»: values в gitops (airflow/<кластер>/<имя>/), Postgres на CloudNativePG с бэкапом в бакет кластера, вход через GitLab платформы (участники команды-владельца — Admin, viva — Viewer), DAG'и из репозитория через git-sync по токену только на чтение, образ — от apache/airflow с зависимостями из requirements.txt (пайплайн репозитория DAG'ов, компонент airflow-path). Пароли и ключи — в Vault кластера, secret/platform/airflow/<имя>."
    emptyContent={
      <EmptyState
        missing="data"
        title="Инстансов Airflow пока нет"
        description="Создайте инстанс из шаблона «Airflow»: он поднимется в выбранном кластере вместе с репозиторием DAG'ов."
      />
    }
  />
);
